import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeStyleSvg } from './NeStyleSvg'

export const NeStyleIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeStyleSvg} {...props} />
}
